import * as React from "react";
import type { SVGProps } from "react";
const SvgErrorInfo = (props: SVGProps<SVGSVGElement>) => (
  <svg
    xmlns="http://www.w3.org/2000/svg"
    width={24}
    height={24}
    fill="none"
    {...props}
  >
    <path
      fill="#A51E19"
      d="M12 0C9.803 0 7.655.683 5.828 1.962a11.54 11.54 0 0 0-4.092 5.223 12.15 12.15 0 0 0-.632 6.725 11.8 11.8 0 0 0 3.041 5.959 10.96 10.96 0 0 0 5.69 3.184c2.154.449 4.388.218 6.418-.663 2.03-.882 3.765-2.374 4.985-4.288a12.04 12.04 0 0 0 1.871-6.467c0-1.528-.287-3.041-.845-4.453a11.7 11.7 0 0 0-2.408-3.776A11.1 11.1 0 0 0 16.25.884 10.7 10.7 0 0 0 12 0m0 18.18c-.25 0-.493-.077-.7-.222a1.3 1.3 0 0 1-.464-.592 1.4 1.4 0 0 1-.072-.763 1.34 1.34 0 0 1 .345-.675c.176-.185.4-.31.645-.362.245-.05.498-.024.728.075.23.1.427.27.565.487s.212.472.212.733c.001.173-.03.345-.094.506-.063.16-.156.306-.273.43q-.177.185-.41.286c-.152.067-.316.1-.482.1zm.8-4.888a.86.86 0 0 1-.25.56.78.78 0 0 1-.549.23.78.78 0 0 1-.549-.23.86.86 0 0 1-.25-.56l-.537-6.647a1.5 1.5 0 0 1 .063-.573c.06-.183.154-.353.28-.496.124-.143.276-.258.446-.336a1.28 1.28 0 0 1 1.075 0c.17.078.322.193.447.336s.22.313.278.496c.06.184.081.38.064.573z"
    />
  </svg>
);
export default SvgErrorInfo;
